// extracted by mini-css-extract-plugin
module.exports = {"custom-arrow":"styles__custom-arrow___1v-pB","icon":"styles__icon___3yDsq","right":"styles__right___2RmZ6","left":"styles__left___spW9S"};